module.exports = __webpack_public_path__ + "static/vib_play6-524a40fd353868bcc7c3692cd7b849eb.jpg";